import { render, staticRenderFns } from "./Verschiedenes.vue?vue&type=template&id=2d07c8a4&"
import script from "./Verschiedenes.vue?vue&type=script&lang=js&"
export * from "./Verschiedenes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports